"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mulazzano": {
    "cefa1223": [{
      "hkey": "86d1589c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "mulazzano": [{
      "hkey": "86d1589c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d715ba0f": [{
      "hkey": "02f62c68",
      "slug": "mulazzano",
      "name": "Mulazzano",
      "primary": true,
      "skipSearch": false
    }],
    "roncomarzo": [{
      "hkey": "02f62c68",
      "slug": "mulazzano",
      "name": "Mulazzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;